module.exports = __webpack_public_path__ + "static/img/profile.4f7ee0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/profile.jpg
// module id = Gxel
// module chunks = 4